export default __webpack_public_path__ + "static/media/logo_pp.a314798a.png";